

import Vue from "vue";
import msDataProvider from "@/services/msDataProvider";

export default Vue.extend({
  data() {
    return {
      isTouched: false,
      isLoading: false,
      isFeedbackSent: false,
      feedback: {
        content: "",
        attached_files: {},
      }
    }
  },
  methods: {
    async sendFeedback() {
      try {
        if (this.isLoading) {
          return;
        }
        const params = {...this.feedback};
        this.isLoading = true;
        await msDataProvider.executeCommand("feedbackCreate", params);
        this.isLoading = false;
        this.isFeedbackSent = true;
        this.feedback = {
          content: "",
          attached_files: {},
        };
        this.isTouched = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
    handleBlur() {
      this.isTouched = true;
    }
  },


  destroyed() {
  }
})
